import { Link } from 'react-router-dom';
import { ClipboardList, Calendar, Users, AlertTriangle, Boxes, ArrowRight } from 'lucide-react';

interface QuickLinkProps {
  title: string;
  description: string;
  href: string;
  icon: typeof ClipboardList;
}

function QuickLink({ title, description, href, icon: Icon }: QuickLinkProps) {
  return (
    <Link
      to={href}
      className="group block rounded-lg border border-border bg-background p-6 hover:border-primary hover:shadow-sm transition-all"
    >
      <div className="flex items-start gap-4">
        <div className="rounded-lg bg-primary/10 p-3">
          <Icon className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-foreground group-hover:text-primary transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-muted mt-1">{description}</p>
        </div>
        <ArrowRight className="h-5 w-5 text-foreground-subtle group-hover:text-primary transition-colors" />
      </div>
    </Link>
  );
}

export function DashboardPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          Planner Workbench
        </h1>
        <p className="text-sm text-foreground-muted mt-1">
          Production scheduling and resource management
        </p>
      </div>

      {/* Quick links */}
      <div className="grid gap-4 md:grid-cols-2">
        <QuickLink
          title="Orders"
          description="View and manage sales orders, set priorities"
          href="/orders"
          icon={ClipboardList}
        />
        <QuickLink
          title="Schedule"
          description="View the production schedule timeline"
          href="/schedule"
          icon={Calendar}
        />
        <QuickLink
          title="People"
          description="Manage workers, skills, and availability"
          href="/people"
          icon={Users}
        />
        <QuickLink
          title="Alerts"
          description="Review exceptions and resolve issues"
          href="/alerts"
          icon={AlertTriangle}
        />
        <QuickLink
          title="Inventory"
          description="View current inventory and project allocations"
          href="/inventory"
          icon={Boxes}
        />
      </div>

      {/* Placeholder for dashboard widgets */}
      <div className="rounded-lg border border-dashed border-border bg-background p-8 text-center">
        <p className="text-foreground-muted">
          Dashboard widgets will be added in Phase 2
        </p>
      </div>
    </div>
  );
}
